<template lang="pug">
    section.prices-tab.not-translatable(v-if="activeTranslation")
        .panel
            .icon
                //- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path class="fa-secondary" opacity=".4" d="M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 192c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/><path class="fa-primary" d="M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM192 192c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>
                //- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path class="fa-secondary" opacity=".4" d="M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM256 80c-13.3 0-24 10.7-24 24V216c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/><path class="fa-primary" d="M280 104c0-13.3-10.7-24-24-24s-24 10.7-24 24V216c0 13.3 10.7 24 24 24s24-10.7 24-24V104zM256 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/></svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM459.9 448H96c-17.7 0-32-14.3-32-32V135.4L32 110.2V416c0 35.3 28.7 64 64 64H500.4l-40.5-32zM544 32H139.6l40.5 32H544c17.7 0 32 14.3 32 32V376.6l32 25.3V96c0-35.3-28.7-64-64-64zM423.3 256l40.5 32H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H423.3zM144 256c-8.8 0-16 7.2-16 16s7.2 16 16 16H257.2l-40.5-32H144zm160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h74.8l-40.5-32H304zm-160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"/></svg>
            h4 {{ $t('Product prices are not translatable') }}
            p(v-if="form.type === 'coupon'") {{ $t('You should go to the "Product" tab') }}
            p(v-else) {{ $t('You should go to either the "Product" tab or the "Sub-Articles" tab') }}
    section.prices-tab(v-else)
        ArticleOverridesNotice(:form="form" :kinds="['prices']")
        Price(
            v-if="mainPriceIndex >= 0"
            :hide-special-prices="hideSpecialPrices"
            :form="form"
            :rules="rules"
            :price="form.prices[mainPriceIndex]"
            :deletable="false"
        )
        hr.wave(v-if="specialPrices.length")
        transition(name="slide-decent-vertical")
            .special-prices(v-if="specialPrices.length")
                transition-group(name="slide-decent-vertical" tag="div")
                    Price(
                        v-for="(price, i) in form.prices" :key="price.id"
                        v-if="price.type !== 'main'"
                        :hide-special-prices="hideSpecialPrices"
                        :form="form"
                        :rules="rules"
                        :price="price"
                    )

        transition(name="slide-decent-vertical")
            .alert.danger(v-if="missingGroups.length && form.prices[mainPriceIndex] && form.prices[mainPriceIndex].value")
                slot(name="warning")
                    p {{ $t('Be aware that only customers within customer groups with defined prices will be able to see this product!') }}<br/>
                        | {{ $t('Consider generating the missing prices by clicking the button below.') }}

        el-button(
            v-if="missingGroups.length && form.prices[mainPriceIndex] && form.prices[mainPriceIndex].value"
            type="warning"
            @click="generateMissingGroupPrices"
        ) {{ $t('Generate missing customer group prices') }}
        el-button(
            v-if="!hideSpecialPrices"
            type="primary"
            icon="el-icon-fa-plus fas"
            @click="addSalePrice"
        ) {{ $t('Add special price') }}
        el-button(
            v-else-if="missingGroups.length > 0"
            type="primary"
            icon="el-icon-fa-plus fas"
            @click="addSalePrice"
        ) {{ $t('Add customer group price') }}
</template>

<i18n>
{
    "de": {
        "Be aware that only customers within customer groups with defined prices will be able to see this product!": "Dieses Produkt wird nur Kunden in Kundenguppen mit vorhandenen Preisen angezeigt!",
        "Consider generating the missing prices by clicking the button below.": "Die fehlenden Preise können per Klick auf die untere Schaltfläche generiert werden.",
        "Generate missing customer group prices": "Fehlende Kundengruppenpreise generieren",
        "Add special price": "Sonderpreis hinzufügen",
        "Add customer group price": "Kundengruppenpreis hinzufügen",

        "Product prices are not translatable": "Produktpreise sind nicht übersetzbar",
        "You should go to either the \"Product\" tab or the \"Sub-Articles\" tab": "Sie sollten entweder zum Tab \"Produkt\" oder zum Tab \"Unterartikel\" wechseln",
        "You should go to the \"Product\" tab": "Sie sollten zum Tab \"Produkt\" wechseln"
    }
}
</i18n>

<script>
import _ from 'lodash';
import uniqid from 'uniqid';

import pinia from '@/pinia';
import { useSetupStore, useShopProductStore } from '@/stores';

import ArticleOverridesNotice from './Partials/ArticleOverridesNotice';
import Price from './Partials/Price';

export default {
    name: 'PricesTab',
    props: {
        hideSpecialPrices: {
            type: Boolean,
            default: false
        }
    },
    components: {
        ArticleOverridesNotice,
        Price
    },
    computed: {
        activeTranslation() {
            if (this.form.translationOrigin) return this.form
        },
        mainPriceIndex() {
            const prices = this.form.prices || []
            return prices.findIndex(el => el.type === 'main');
        },
        specialPrices() {
            const prices = this.form.prices || []
            return prices.filter(el => el.type !== 'main');
        },
        groupPrices() {
            const prices = this.form.prices || []
            return prices.filter(el => el.type === 'group' && el.customerGroup != null);
        },
        missingGroups() {
            // check if all customer groups have their own prices

            let missingGroups = [];

            const defaultCustomerGroup = _.get(this.activeShop, 'defaultCustomerGroup');
            const groups = this.options.customerGroup.items;

            if (defaultCustomerGroup && groups.length) {
                const existingGroupIDs = this.groupPrices.map(el => el.customerGroup.id);
                missingGroups = groups.filter(el => {
                    return el.id !== defaultCustomerGroup.id && !existingGroupIDs.includes(el.id);
                });
            }

            return missingGroups;
        },
        activeShop() {
            return this.activeCms.shop;
        },
        setupStore() {
            return useSetupStore();
        },
        shopProductStore() {
            return useShopProductStore(pinia);
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        form() {
            return this.shopProductStore.form;
        },
        rules() {
            return this.shopProductStore.rules;
        },
        options() {
            return this.shopProductStore.options;
        }
    },
    methods: {
        generateMissingGroupPrices() {
            if (this.missingGroups && this.missingGroups.length) {
                this.missingGroups.forEach(customerGroup => {
                    this.addPrice({
                        id: uniqid('new:'),
                        value: _.get(this.form.prices[this.mainPriceIndex], 'value'),
                        tax: _.get(this.form.prices[this.mainPriceIndex], 'tax'),
                        tax_rate: _.get(this.form.prices[this.mainPriceIndex], 'tax_rate'),
                        type: 'group',
                        customerGroup,
                        start_at: null,
                        end_at: null
                    });
                });
            }
        },
        addSalePrice() {
            const customerGroup = _.get(this.activeShop, 'defaultCustomerGroup');

            this.addPrice({
                id: uniqid('new:'),
                value: _.get(this.form.prices[this.mainPriceIndex], 'value'),
                tax: _.get(this.form.prices[this.mainPriceIndex], 'tax'),
                tax_rate: _.get(this.form.prices[this.mainPriceIndex], 'tax_rate'),
                type: 'sale',
                customerGroup,
                start_at: null,
                end_at: null
            });
        },
        addPrice(price) {
            return this.shopProductStore.addFormPrice(price);
        }
    }
};
</script>

<style lang="sass" scoped>
.special-prices
    // border-top: 3px dotted $--shop-color-primary
    // padding-top: 22px
.not-translatable
    .panel
        background: $color-skeleton
        border-radius: 4px
        padding: 1rem

        display: flex
        flex-direction: column
        justify-content: center
        align-items: center
        padding: 4rem
        text-align: center

    .icon
        width: 4rem
        color: $--color-warning
        svg
            fill: currentColor
    h4
        margin-top: 1rem
        margin-bottom: 0
        font-size: 2rem
        font-weight: 300
        color: $--color-warning
    p
        color: rgba(0,0,0,0.6)
</style>
